<template>
  <ux-form
    ref="form"
    :data="formData"
    width="440px"
    :colon="true"
    :rules="rules"
    label-width="70px"
    data-automation="approval"
  >
    <ux-form-item :label="$t('HT.approval.status')" prop="status">
      <ux-radio v-model="formData.status" :options="$opt.approval" @change="change"></ux-radio>
    </ux-form-item>
    <ux-form-item
      :label="$t('HT.approval.message')"
      prop="message"
      v-if="this.formData.status == 2"
      start
    >
      <ux-input
        v-model="formData.message"
        type="textarea"
        size="small"
        :autosize="{ minRows: 3, maxRows: 3 }"
        :maxlength="32"
        show-word-limit
        :placeholder="$t('HT.approval.message.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item
      :label="$t('HT.addLicense.maxConn')"
      v-if="this.formData.status == 1"
      prop="max_conn"
    >
      <ux-input
        v-model="formData.max_conn"
        :maxlength="6"
        :placeholder="$t('HT.approval.maxConn.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item
      :label="$t('HT.addLicense.maxHosts')"
      v-if="this.formData.status == 1"
      prop="max_hosts"
    >
      <ux-input
        v-model="formData.max_hosts"
        :maxlength="3"
        :placeholder="$t('HT.addLicense.maxHosts.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item
      :label="$t('HT.approval.remark')"
      start
      v-if="this.formData.status == 1"
      prop="remark"
    >
      <ux-input
        v-model="formData.remark"
        type="textarea"
        size="small"
        :autosize="{ minRows: 5, maxRows: 5 }"
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          status: '', // 审批
          message: null, // 原因
          max_conn: '', // 最大连接数
          max_hosts: '', // 最大网卡数
          remark: null // 扩展
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.approval()
    };
  },
  methods: {
    /**
     * 正则校验
     */
    change() {
      this.$refs['form'].clearValidate();
    }
  }
};
</script>
